module.exports = __webpack_public_path__ + "static/media/Mesa-Atencion.85270a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-Atencion.jpg
// module id = 139
// module chunks = 0